import sendReqUtil from './send-req-util';
import locales from '../locales/locales';
import langMap from '../constants/lang-map';
const submitFormUtil=async(endpoint,fields,customErrors,contentType,uploadId)=>{
    if(customErrors===undefined){
        customErrors={};
    }
    if(contentType===undefined){
        contentType='json';
    }
    for(const [_,v] of Object.entries(fields)){
        v[1](null);
    }
    let reqBody=null;
    if(contentType==='json'){
        reqBody={};
        for(const [k,v] of Object.entries(fields)){
            reqBody[k]=v[0];
        }
    }
    else if(contentType==='form'){
        reqBody=new FormData();
        for(const [k,v] of Object.entries(fields)){
            if(!v[0]){
                continue;
            }
            if(v[0].constructor.name==='Array'){
                for(const x of v[0]){
                    reqBody.append(k,x);
                }
            }
            else{
                reqBody.append(k,v[0]);
            }
        }
    }
    else{
        console.assert(false);
    }
    const res=await sendReqUtil(endpoint,reqBody,uploadId);
    if(res.status===200){
        return res.body;
    }
    else if(res.status===422){
        for(const x of res.body.detail){
            fields[x.loc[1]][1](Object.fromEntries(Object.keys(langMap).map(y=>[y,x.msg])));
        }
    }
    else if(Math.floor(res.status/100)===4){
        if(typeof(customErrors[res.body.detail])==='object'){
            for(const [k,v] of Object.entries(customErrors[res.body.detail])){
                fields[k][1](v);
            }
        }
        else{
            customErrors[res.body.detail]();
        }
    }
    else{
        for(const x of Object.values(fields)){
            x[1](locales.utilSomethingWentWrong);
        }
    }
};
export default submitFormUtil;

